<template>
  <div class="vm-input-wrap">
    <input class="vm-input"
      @input="$emit('input', $event.target.value)"
      :value="value"
      :class="classes"
      :disabled="disabled"
      :placeholder="placeholder"
      :type="type" />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        'vm-invalid': this.invalid
      };
    }
  }
};
</script>

<style scoped>
.vm-input {
  display: block;
  width: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background-color: #f2f2f2;
  outline: none;
  border-radius: 4px;
  padding: 6px;
  padding-left: 12px;
  font-size: 16px;
  transition: box-shadow 300ms ease;
  font-weight: 500;
  color: #06003C;
  height: 36px;
}
.vm-input:focus {
  border: 0;
  box-shadow: inset 0 0 8px 5px rgba(0, 0, 0, 0.03);
}
.vm-invalid.vm-input:focus,
.vm-invalid {
  box-shadow: inset 0 0 0 1px rgba(200, 0, 0, 0.5);
}
.vm-invalid::placeholder {
  color: rgba(200, 0, 0, 0.5);
}
.vm-input:disabled {
  background-color: #ebebeb;
  color: #a7a7a7;
}
</style>
